import { useState, useEffect } from "react";
import tw from "tailwind-styled-components";
import { useMutation } from "react-query";
import axios from "axios";
import Config from "../../Config";
import Loading from "../../Components/Loading";
import {
  BoxContainer,
  BoxTitle,
  BoxHead,
  Underline,
  FilterTableWrapper,
  FilterWrapper,
} from "../../Components/Styles/PageStyles";
import NotFoundModel from "../../Components/NotFoundModel";
import { useDispatch, useSelector } from "react-redux";
import SearchFilterBox from "../../Components/SearchFilterBox";
import Table from "../../Components/Landlords/Table";
import { toast } from "react-toastify";
import SideModal from "../../Components/SideModal";
import AddLandlord from "../../Components/Landlords/AddLandlord";
import EditLandlord from "../../Components/Landlords/EditLandlord";
import DeleteOwner from "../../Components/Landlords/DeleteOwner";
import { Save_Owners } from "../../Redux/actions";
import ViewInventoriesModel from "../../Components/Common/ViewInventoriesModel";
import { AddBtn } from "../../Components/Styles/InputStyles";

const LandlordsList = () => {
  const searchOptions = [
    { label: "Mobile", value: 1 },
    { label: "Name", value: 2 },
    // { label: "Inventory Name", value: 3 },
  ];

  const dispatch = useDispatch();
  const user = useSelector((state) => state.UserReducer.user);
  const [selectedData, setSelectedData] = useState("");
  const [apiData, setApiData] = useState([]);
  const [filterType, setFilterType] = useState("");
  const [searchQuery, setSearchQuery] = useState("");
  const [showEditLandlord, setShowEditLandlord] = useState(false);
  const [showAddOwner, setShowAddOwner] = useState(false);
  const [showViewProps, setShowViewProps] = useState(false);
  const [isDeleteOwners, setIsDeleteOwners] = useState(false);
  const [inventoryList, setInventoryList] = useState([]);

const getFilterType = (type) => {
    switch (type) {
      case 1:
        return "MOBILE";
      case 2:
        return "NAME";
      case 3:
        return "INVENTORY_NAME";
      default:
        return "";
    }
  };

  const fetchFunction = async (params) => {
    const query = `&s=${params.searchQuery || ""}&t=${params.filterType || ""}`;
    const response = await axios.get(
      `${Config.apiUrl}/owner/list?${query}`,
      {
        headers: {
          authorization: "Bearer " + user.token,
          "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
        },
      }
    );
    return response.data;
  };

  const getSuccess = (res) => {

    if (res?.isSuccess) {
      const list = res?.list;

      const formattedList = Array.isArray(list)
        ? list
        : list
        ? [list]
        : [];

      setApiData(formattedList);
      dispatch(Save_Owners(formattedList));
    }
  };

  const getError = (err) => {
    toast.error(err?.response?.data?.msg || "An Error Occured");
  };

  const {
    isLoading,
    mutate: getListMutate,
    error,
    isRefetching,
    data,
    refetch,
  } = useMutation(fetchFunction, {
    onSuccess: getSuccess,
    onError: getError,
  });

  useEffect(() => {
    getListMutate({ searchQuery, filterType });
  }, []);

  const handleFilterChange = (values) => {
  const type = getFilterType(values.filterType);

  setFilterType(type);
  setSearchQuery(values.searchQuery);

  getListMutate({
    searchQuery: values.searchQuery,
    filterType: type,
  });
};

  const handleClearFilters = () => {
    setFilterType("");
    setSearchQuery("");
    getListMutate({ searchQuery: "", filterType: "" });
  };

  const handleCloseEditLandlord = () => {
    setShowEditLandlord(false);
  };
  const handleCloseAddOwner = () => {
    setShowAddOwner(false);
  };

  const handleCloseViewProps = () => {
    setShowViewProps(false);
  };

  //------- Add Landlord details -------
  const addOwnerFunction = async (values) => {
    return await axios.post(
      `${Config.apiUrl}/owner/add`,
      values,
      {
        headers: {
          "Content-Type": "application/json",
          authorization: `Bearer ${user.token}`,
        },
      }
    );
  };

  const addOwnerSuccess = (data) => {
    setShowAddOwner(false);
    getListMutate({ searchQuery, filterType });
    toast.success(data?.data?.msg || "Success");
  };

  const addOwnerError = (data) => {
    toast.error(data?.response?.data?.msg || "An Error Occured");
  };

  const { isLoading: addOwnerLoading, mutate: addOwnerMutate } =
    useMutation(addOwnerFunction, {
      onSuccess: addOwnerSuccess,
      onError: addOwnerError,
    });


  //-------Edit Owners details -------
  const editOwnersDetails = async (values) => {
    return await axios.post(
      `${Config.apiUrl}/owner/edit`,
      values,
      {
        headers: {
          "Content-Type": "application/json",
          authorization: `Bearer ${user.token}`,
        },
      }
    );
  };

  const editOwnersSuccess = (data) => {
    setShowEditLandlord(false);
    getListMutate({ searchQuery, filterType });
    toast.success(data?.data?.msg || "Success");
  };

  const editOwnersError = (data) => {
    toast.error(data?.response?.data?.msg || "An Error Occured");
  };

  const { isLoading: editOwnersLoading, mutate: editOwnersMutate } =
    useMutation(editOwnersDetails, {
      onSuccess: editOwnersSuccess,
      onError: editOwnersError,
    });

  //------- Delete Owners -------
  const deleteOwnersFunction = async (values) => {
    return await axios.post(`${Config.apiUrl}/owner/delete`, values, {
      headers: {
        "Content-Type": "application/json",
        authorization: `Bearer ${user.token}`,
      },
    });
  };

  const deleteLoctationSuccess = (data) => {
    if (data?.data?.isSuccess === true) {
      toast.success(data?.data?.msg || "Success");
      setIsDeleteOwners(false);
      getListMutate({ searchQuery, filterType });
    } else {
      toast.error(data?.data?.msg || "An Error Occured");
    }
  };

  const deleteLocationError = (data) => {
    setIsDeleteOwners(false);
    toast.error(data?.response?.data?.msg || "An Error Occured");
  };

  const { isLoading: deleteOwnersLoading, mutate: deleteOwnersMutate } =
    useMutation(deleteOwnersFunction, {
      onSuccess: deleteLoctationSuccess,
      onError: deleteLocationError,
    });


  const handleLocationClose = () => {
    setIsDeleteOwners(false);
  };

  // ------- Get Inventory List By Inventory Id -------
  const getInventoryListFunction = async (item) => {
    const response = await axios.get(
      `${Config.apiUrl}/inventory/list?&s=${item.id}&t=${Config.USER_TYPE_RETAIL.LANDLORD}`,
      {
        headers: {
          authorization: `Bearer ${user.token}`,
          "Content-Type": "application/json",
        },
      }
    );

    return response.data;
  };

  const getInventoryListSuccess = (res) => {

    if (res?.isSuccess) {
      setInventoryList(res?.data || []);
      setShowViewProps(true);
    }
  };

  const getInventoryListError = (err) => {
    toast.error(err?.response?.data?.msg || "Error fetching Inventory");
  };
  const { mutate: getInventoryListMutate, isLoading: inventoryLoading } =
    useMutation(getInventoryListFunction, {
      onSuccess: getInventoryListSuccess,
      onError: getInventoryListError,
    });

  return (
    <BoxContainer>
      <BoxHead>
        <BoxTitle className="!mb-0 whitespace-nowrap">
          Owners
          <Underline />
        </BoxTitle>
        <div className="flex space-x-4 md:ml-auto">
          <AddBtn
            type="button"
            onClick={() => {
              setShowAddOwner(true);
            }}
          >
            {"Add Owner"}
          </AddBtn>
        </div>
      </BoxHead>

      <SideModal
        isOpen={showEditLandlord}
        onClose={handleCloseEditLandlord}
        level="base"
      >
        <EditLandlord
          handleClose={handleCloseEditLandlord}
          selectedData={selectedData}
          editOwnersMutate={editOwnersMutate}
          editOwnersLoading={editOwnersLoading}
        />
      </SideModal>
      <SideModal
        isOpen={showAddOwner}
        onClose={handleCloseAddOwner}
        level="base"
      >
        <AddLandlord
          handleClose={handleCloseAddOwner}
          selectedData={selectedData}
          addOwnerMutate={addOwnerMutate}
          addOwnerLoading={addOwnerLoading}
        />
      </SideModal>

      <SideModal
        isOpen={showViewProps}
        onClose={handleCloseViewProps}
        level="base"
      >
        <ViewInventoriesModel
          apiData={inventoryList}
          handleClose={handleCloseViewProps}
          selectedData={selectedData}
        />
      </SideModal>

      <FilterTableWrapper>
        <FilterWrapper className="grid grid-cols-1 md:grid-cols-2 gap-4">

          {/* Left: Total Amount */}
          <div className="flex items-center">
            <Text>
              Total owners:{" "}
              <span className="font-semibold">
                {apiData?.length || 0}
              </span>
            </Text>
          </div>

          {/* Right: Search / Filters */}
          <div className="flex flex-col gap-3 md:flex-row md:justify-end md:items-center">
            <SearchFilterBox
              options={searchOptions}
              handleFilterChange={handleFilterChange}
              handleClearFilters={handleClearFilters}
            />
          </div>
        </FilterWrapper>

        {isDeleteOwners && (
          <DeleteOwner
            setIsDeleteOwners={setIsDeleteOwners}
            isDeleteOwners={isDeleteOwners}
            deleteOwnersLoading={deleteOwnersLoading}
            deleteOwnersMutate={deleteOwnersMutate}
            selectedData={selectedData}
            handleClose={handleLocationClose}
          />
        )}
        {!error && !isLoading && data && (
          <TableWrapper>
            <Table
              apiData={apiData || []}
              setSelectedData={setSelectedData}
              selectedData={selectedData}
              setShowEditLandlord={setShowEditLandlord}
              setShowViewProps={setShowViewProps}
              setIsDeleteOwners={setIsDeleteOwners}
              getInventoryListMutate={getInventoryListMutate}
              inventoryLoading={inventoryLoading}
            />
            {(!apiData || apiData.length === 0) && <NotFoundModel />}
          </TableWrapper>
        )}
      </FilterTableWrapper>

      {error && !isLoading && <NotFoundModel />}
      {(isLoading || isRefetching) && <Loading />}
    </BoxContainer>
  );
};

const TableWrapper = tw.div`mt-4 bg-white rounded-md`;

const Text = tw.p`text-gray-500 text-sm font-normal`;

export default LandlordsList;
